<div>
  <hr />
  <b>Admin Section</b>
  <br />

  <b>Providers:</b>
  <div style="display: flex; gap: 10px" [formGroup]="parentForm">
    <div class="space">
      <p-radioButton value="groq" formControlName="provider"></p-radioButton>
      <label class="space">Groq</label>
    </div>

    <div class="space">
      <p-radioButton value="openai" formControlName="provider"></p-radioButton>
      <label>Open AI</label>
    </div>

    <div class="space">
      <p-radioButton value="google" formControlName="provider"></p-radioButton>
      <label class="space">Google</label>
    </div>

    <div class="space">
      <p-radioButton value="openrouter" formControlName="provider"></p-radioButton>
      <label class="space">Open Router</label>
    </div>

    <div class="space">
      <p-radioButton value="ollama" formControlName="provider"></p-radioButton>
      <label class="space">Ollama</label>
    </div>
  </div>

  <b>Modelo: </b>
  <span pTooltip="Modelo Seleccionado">{{ parentForm.controls.modelName.value }}</span>
  @if (parentForm.controls.provider.value) { @if(isLoadingModels) {
  <p-skeleton height="200px" width="100%"></p-skeleton>
  } @else {
  <p-table [value]="modelnames" stripedRows [size]="'small'" [paginator]="true" [rows]="12" [formGroup]="parentForm">
    <ng-template pTemplate="header">
      <tr>
        <th></th>
        <th>Name</th>
        <th>$$Prompt M</th>
        <th>$$Completion M</th>
        <th>$$Cost 90/10 M</th>
        <th>Created</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-model>
      <tr [pTooltip]="model.description | truncate : 200" tooltipPosition="top">
        <td><p-radioButton [value]="model.id" formControlName="modelName"></p-radioButton></td>
        <td>{{ model.name || model.id }}</td>
        <td>${{ +model.pricing?.prompt * 1000000 | number : '1.2-2' }}</td>
        <td>${{ +model.pricing?.completion * 1000000 | number : '1.2-2' }}</td>
        <td>${{ +model.pricing?.prompt * 1000000 * 0.9 + +model.pricing?.completion * 1000000 * 0.1 | number : '1.2-2' }}</td>
        <td>{{ model.created * 1000 | date : 'dd/MM/yyyy' }}</td>
      </tr>
    </ng-template>
  </p-table>
  } }
</div>
